import { loadScript } from '../load-strategies/TwitchSdkLoader';

export default {
  name: 'twitch',
  loader: loadScript,
};
